import $http from "../../helpers/api";
import objectToFormData from "object-to-formdata";

// initial state
const state = {
    all: [],
    assessments: [],
    answers: []
};

// getters
const getters = {
    get: state => state.assessments,
    getAll: state => state.all,
    getAnswers: state => state.answers,
};

const actions = {
    getAll({ commit }) {
        return new Promise((resolve, reject) => {
            $http.get("/assessments").then(resp => {
                commit("setAll", resp.data);
            });
            resolve();
        });
    },
    get({ commit }, assessment_id) {
        return new Promise((resolve, reject) => {
            $http
                .get("/assessments/" + assessment_id)
                .then(resp => {
                    // console.log(resp.data.data.assessments);
                    commit("set", resp.data.data.assessments);
                    resolve(resp);
                }).catch(error => {
                    reject(error);
                });
        });
    },
    add({}, data) {
        let form_data = JSON.stringify(data);
        // return console.log(form_data);
        return new Promise((resolve, reject) => {
            $http.post("/assessments", form_data
            ).then(resp => {
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getAnswers({ commit }, asf_id) {
        return new Promise((resolve, reject) => {
            $http
                .get("/answers/asf/" + asf_id)
                .then(resp => {
                    // console.log(resp.data);
                    commit("setAnswers", resp.data);
                    resolve(resp);
                }).catch(error => {
                    reject(error);
                });
        });
    },
    answer({}, data) {
        let form_data = JSON.stringify(data);
        // return console.log(form_data);
        return new Promise((resolve, reject) => {
            $http.post("/answers", form_data
            ).then(resp => {
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    },
    edit({
        commit
    }, data) {
        let form_data = JSON.stringify(data);
        // return console.log(form_data);
        return new Promise((resolve, reject) => {
            $http.post("/assessments/" + data.id, form_data
            ).then(resp => {
                commit("clearAll");
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    },
    delete({}, data) {
        return new Promise((resolve, reject) => {
            $http.delete("/assessments/" + data).then(resp => {
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    }
};
const mutations = {
    setAll(state, data) {
        state.all = data;
    },
    clearAll(state) {
        state.all = [];
        state.assessments = [];
        state.answers = [];
    },
    set(state, assessments) {
        state.assessments = assessments;
    },
    setAnswers(state, answers) {
        state.answers = answers;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
